/**
 * Resolves an app-root-relative path, prefixing the production /portal base when needed.
 */
export function resolveAppPath(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const baseUrl = import.meta.env.BASE_URL;

  if (baseUrl === '/') {
    return normalizedPath;
  }

  return `${baseUrl.replace(/\/$/, '')}${normalizedPath}`;
}

/**
 * Returns the current pathname without the router basename (e.g. strips /portal).
 * Matches paths stored via react-router location.pathname.
 */
export function getRouterPathname(pathname = window.location.pathname): string {
  const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

  if (basename && pathname.startsWith(basename)) {
    return pathname.slice(basename.length) || '/';
  }

  return pathname;
}

/** Full URL for resources loaded outside axios (img src, window.open, etc.). */
export function resolveAppUrl(path: string): string {
  return `${window.location.origin}${resolveAppPath(path)}`;
}
